// extracted by mini-css-extract-plugin
export default {"cardapio__filtros":"Cardapio_cardapio__filtros__WpwJK"};